module.exports = __webpack_public_path__ + "img/north-korea.bc191f10.svg";